import { useRef } from "react";
import { Loader2, Upload } from "lucide-react";
import type { FileKind } from "@bookdental/schemas";
import { useFileUpload } from "./use-file-upload";

type Props = {
  kind: FileKind;
  onUploaded: (file: { fileId: string; name: string }) => void;
  disabled?: boolean;
};

/** Botão compacto de upload — substitui a caixa de arrastar-e-soltar na tela principal de
 *  Arquivos. O arraste continua funcionando, só que direto na área da pasta (ver Arquivos.tsx),
 *  igual Google Drive/Dropbox: não precisa de uma zona dedicada só pra isso. */
export function FilesUploadButton({ kind, onUploaded, disabled }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { uploading, total, doneCount, handleFiles } = useFileUpload({ kind, onUploaded });

  async function handleChange(fileList: FileList | null) {
    await handleFiles(fileList);
    if (inputRef.current) inputRef.current.value = "";
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        className="hidden"
        onChange={(e) => void handleChange(e.target.files)}
      />
      <button
        type="button"
        disabled={disabled || uploading}
        onClick={() => inputRef.current?.click()}
        className="inline-flex h-9 items-center gap-1.5 rounded-md bg-brand-600 px-3 text-sm font-medium text-white transition-colors hover:bg-brand-700 disabled:opacity-60"
      >
        {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        {uploading ? `Enviando... (${doneCount}/${total})` : "Anexar arquivo"}
      </button>
    </>
  );
}
